import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import createMarkup from '@xanadu/ui-shared/utils/createMarkupHTML';

import IconClose from '../../../images/icons/misc/close.svg';

import styles from './GlobalBanner.module.scss';

const GlobalBanner = ({
  dismissBanner,
  bannerBackgroundColor,
  bannerDismissBehaviour,
  globalBannerMessage,
  globalBannerPortal,
}) => {
  const [visible, setVisible] = useState(true);

  const portalTarget = document.getElementById(globalBannerPortal);

  const handleDismiss = () => {
    if (bannerDismissBehaviour === 'until-update') {
      dismissBanner();
    }

    setVisible(false);
  };

  const canClose = bannerDismissBehaviour !== 'persistent';

  const style = {
    backgroundColor: `#${bannerBackgroundColor}`
  };

  const bannerContent = (
    <div className={styles.base} >
      <div style={style} className={styles.container} >
        <span
          className={styles.message}
          dangerouslySetInnerHTML={createMarkup(globalBannerMessage)}
        />
        {
          canClose
            ? (
              <a
                className={styles.close}
                role="button"
                tabIndex={0}
                onClick={handleDismiss}
              >
                <IconClose className={styles.closeIcon} />
              </a>
            )
            : null
        }
      </div>
    </div>
  );

  if (!globalBannerMessage || !visible || !portalTarget) {
    return null;
  }

  return (
    createPortal(
      bannerContent,
      portalTarget
    )
  );
};

GlobalBanner.propTypes = {
  dismissBanner: PropTypes.func.isRequired,
  bannerBackgroundColor: PropTypes.string.isRequired,
  bannerDismissBehaviour: PropTypes.string.isRequired,
  globalBannerMessage: PropTypes.string.isRequired,
  globalBannerPortal: PropTypes.string,
};

export default GlobalBanner;
